import { render } from "./JobTaskElement.vue?vue&type=template&id=54c60612&scoped=true&ts=true"
import script from "./JobTaskElement.vue?vue&type=script&lang=ts"
export * from "./JobTaskElement.vue?vue&type=script&lang=ts"

import "./JobTaskElement.vue?vue&type=style&index=0&id=54c60612&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c60612"]])

export default __exports__